exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3y6aO1nL87uEMKCc60sF2i{color:#a4a4a4;font-size:1rem;font-weight:400;margin:0}._2sk-UJRDvCXFSjFyydl5Rh{padding:1.42857rem;padding-bottom:0!important;width:100%}@media only screen and (min-width:640px){._2sk-UJRDvCXFSjFyydl5Rh{padding:1.42857rem 2.14286rem}}._3ECVJIv5vkLLcVtWtdt6CA:not(:last-child){margin-bottom:0!important}._3aRUqy0hdJgWxu7EJpio5e{margin-left:-1.07143rem}._3aRUqy0hdJgWxu7EJpio5e [data-prop=name]{font-weight:400;text-decoration:underline}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"PersonalisedHomeworkViewCard_heading": "_3y6aO1nL87uEMKCc60sF2i",
	"PersonalisedHomeworkViewCard_students": "_2sk-UJRDvCXFSjFyydl5Rh",
	"PersonalisedHomeworkViewCard_studentCell": "_3ECVJIv5vkLLcVtWtdt6CA",
	"PersonalisedHomeworkViewCard_studentProfile": "_3aRUqy0hdJgWxu7EJpio5e"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.3/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/AssignHomework/Assignments/PersonalisedHomeworkViewCard/style.postcss
// module id = 1729
// module chunks = 0